export const MARGIN_DATA = "MARGIN_DATA";
export const MARGIN_ERROR_DATA = "MARGIN_ERROR_DATA";
export const MARGIN_HIDE_ERROR_DATA = "MARGIN_HIDE_ERROR_DATA";
export const MARGIN_START_LOADER = "MARGIN_START_LOADER";
export const MARGIN_STOP_LOADER = "MARGIN_STOP_LOADER";
